export default __webpack_public_path__ + "static/media/feature-tile-icon-01.e13cef8e.svg";